import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebaseconfig';
import Modal from './Modal';
import { doc, getDoc } from 'firebase/firestore';
import { Navbar } from './NavBar';
import { AuthContext } from './AuthContext';

export function LoginJudge() {

    const navigate = useNavigate();

    const { user, signOut } = useContext(AuthContext)

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [showAlert, setShowAlert] = useState(false)

    useEffect(() => {

        // Set default back navigation to home page
        const handlePopState = (event) => {
          event.preventDefault();
          navigate("/", { replace: true });
        };

        window.addEventListener("popstate", handlePopState);

        const redirect = async() => {

            // If user is logged in and is a judge redirect to the vote page
            if (user) {

                if ((await getDoc(doc(db, "judges", user.uid))).exists()) {
                    navigate("/vote-judge", { replace: true})
                    return
                }

            }
        }

        redirect()

        return () => {window.removeEventListener("popstate", handlePopState);}

    }, [navigate, user]);

    function handleJudgeSignIn () {

        signInWithEmailAndPassword(auth, email, password)
        .then((user) => {
            navigate("/vote-judge")
        })
        .catch((error) => {
            setShowAlert(true)
        })
    
    }

    return (

        <div className='background-container'>

            <Navbar text1="Közönség Szavazás" onClick1={() => navigate("/vote-fans")} text2="Kijelentkezés" onClick2={() => {signOut();setEmail('');setPassword('')}}/>

        <div className="container">  
            <div className="login-container">
                <h2>Zsűri Bejelentkezés</h2>
                <div className="input-group">
                    <label htmlFor="email">Email</label>
                    <input
                    type="email"
                    id="email"
                    placeholder="email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="password">Jelszó</label>
                    <input
                    type="password"
                    id="password"
                    placeholder="Írja be a jelszavát"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    />
                </div>
                <button className="login-button" onClick={handleJudgeSignIn}>Bejelentkezés</button>
            </div>
            {showAlert && <Modal show={showAlert} onClose={() => setShowAlert(false)}>
                <p style={{ color: "black" }}>Hibás Bejelentkezési Adatok!</p>
            </Modal>}
        </div>  

        </div>
    );

}


